import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Campo} from '../../models/coleta';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { of } from 'rxjs/internal/observable/of';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { ConsultaExternaService } from 'src/app/services/consulta-externa.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-reanalysis-page',
  templateUrl: './reanalysis-page.component.html',
  styleUrls: ['./reanalysis-page.component.scss']
})
export class ReanalysisPageComponent{
  campoDocumento: Campo = {
    // titulo: "Documento",
    codigo: "pessoa.reanalise.cpf",
    tipo: "NUMERICO",
    descricao: "CPF",
    atributos: [
      {
        id: 1,
        propriedade: 'OBRIGATORIEDADE',
        configuracao: 'origem=whitelabel',
        valor: 'true'
      },
      {
        id: 2,
        propriedade: 'MASCARA',
        configuracao: 'origem=whitelabel',
        valor: '###.###.###-##'
      },
      {
        id: 3,
        propriedade: 'MODO_ENTRADA',
        configuracao: 'origem=whitelabel',
        valor: 'numeric'
      },
      {
        id: 4,
        propriedade: 'PADRAO',
        configuracao: 'origem=whitelabel',
        valor: '^\\d{11}$'
      }
    ]
  };
  formGroup: UntypedFormGroup;
  isLoading = false;
  description: string | undefined = 'Por favor informe o seu documento abaixo.';
  isSubmited = false;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private sessionStorageService: SessionStorageService,
    private consultaExternaService: ConsultaExternaService,
  ) {
    this.formGroup = this.fb.group({});
  }


  isValid(): boolean {
    const invalidEntries = Object.keys(this.formGroup.controls).filter(key => !this.formGroup.controls[key]?.valid);

    return !invalidEntries.includes(this.campoDocumento.codigo || "");
  }

  changeStep(): void {
    const envConfig = this.sessionStorageService.getEnvConfig();
    this.isLoading = true;
    this.isSubmited = true;
    const documento = this.formGroup.controls[this.campoDocumento?.codigo || ""]?.value
    this.consultaExternaService.consultarFluxo(
      {
      clienteDocumento: documento
      , produto: Number(envConfig.consultaExternaConfig?.idProdutoExterno)
      , fluxoIdentificador: envConfig.consultaExternaConfig?.tipo || ""
      , origem: "WHITELABEL"
    })
    .subscribe({
      next: response => {
        this.isLoading = false;
        this.isSubmited = false;

        if(response?.mensagem) {

          this.dialog.open(DialogComponent, {
            width: "250px",
            data: { title: "Oooops!", message: envConfig.mensagemReprovacao },
          });

          this.router.navigate(['/']);
          return;
        }

        envConfig.consultaExternaConfig = {
          ...envConfig.consultaExternaConfig,
          fluxoId: response.fluxo,
          documentoCliente: documento,
        };
        this.sessionStorageService.saveEnvConfig(envConfig);

        this.router.navigate(['/iniciar']);

      },
      error: err => {
        this.isLoading = false;
        this.isSubmited = false;
        this.dialog.open(DialogComponent, {
          width: "250px",
          data: { title: "Oooops!", message: "Ocorreu algum erro. Por favor tente novamente mais tarde." },
        });
        console.log(err);
      }
    });
  }

}
